import React from 'react';
import { RocheHeadline as RocheHeadlineType } from '../../types/global';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';

type RocheHeadlineProps = BlokToComponentProps<
  RocheHeadlineType & {
    headline: string;
    level: string;
  }
>;

export const RocheHeadline = ({ blok: { headline, level }, slot }: RocheHeadlineProps): JSX.Element => {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  return (
    <roche-headline slot={slot} level={level}>
      <Tag className={`headline headline--${level}`}>{headline}</Tag>
    </roche-headline>
  );
};
